<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4279_1343)">
      <path
        d="M2.2207 4.48877H7.77926C8.14723 4.48877 8.50011 4.63494 8.76029 4.89512C9.02047 5.1553 9.16665 5.50818 9.16665 5.87616V8.09688H0.833313V5.87616C0.833313 5.50818 0.979484 5.1553 1.23967 4.89512C1.49985 4.63494 1.85274 4.48877 2.2207 4.48877Z"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.833313 8.10132V8.56078"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.16663 8.10132V8.56078"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.70271 4.84459V2.63739C8.70271 2.26943 8.55654 1.91654 8.29636 1.65636C8.03618 1.39617 7.68329 1.25 7.31532 1.25H2.68469C2.31673 1.25 1.96384 1.39617 1.70366 1.65636C1.44347 1.91654 1.2973 2.26943 1.2973 2.63739V4.84459"
        :stroke="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4279_1343">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
import {DEFAULT_BRAND_COLOR} from '../constants';

export default {
  inject: ['getBrandPrimaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandPrimaryBackground();
      return stroke || DEFAULT_BRAND_COLOR;
    },
  },
};
</script>
